import React from "react";
import { DoctorMapping } from "../api/models";
import { DoctorOptimedLabel } from "./DoctorOptimedLabel";
import { DoctorDocplannerLabel } from "./DoctorDocplannerLabel";
import { Badge } from "@optimed/react";
import { Identifier } from "./Identifier";
import { AddressLabel } from "./AddressLabel";

interface DoctorLabelProps {
  doctor: DoctorMapping;
}

export function DoctorLabel(props: DoctorLabelProps) {
  const { doctor } = props;
  const address = doctor.docplanner?.address;
  return (
    <div>
      <div>
        <DoctorDocplannerLabel doctor={doctor.docplanner} />
        {doctor.his && " / "}
        <DoctorOptimedLabel doctor={doctor.his?.doctor} />{" "}
        {doctor.mappingAutomatic && (
          <Badge
            type="secondary"
            text="Auto"
            title="Powiązanie lekarza wyznaczone automatycznie"
          />
        )}
        {doctor.docplanner?.address?.isOnlineOnly && (
          <Badge
            type="info"
            text="Online"
            title="Grafik dedykowany dla wideokonsultacji oraz teleporad"
          />
        )}
      </div>
      <div className="small">
        <span>
          <AddressLabel address={address} />
        </span>
        <span hidden={!doctor.his}>
          {" "}
          / {doctor.his?.unit?.nazwa}{" "}
          <Identifier value={doctor.his?.unit?.id} />
        </span>
      </div>
      {doctor.docplanner?.doctor?.licenseNumber && (
        <div className="small" title="NPWZ w serwisie Znany Lekarz">
          NPWZ: {doctor.docplanner?.doctor?.licenseNumber}
        </div>
      )}
    </div>
  );
}
